(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CustomilyFaceCutOutService', CustomilyFaceCutOutService);

    function CustomilyFaceCutOutService(
        blockUI,
        CustomilyFaceCutOutAPIService,
        MultipleFileUploadService,
        $window,
        $mdDialog,
        $timeout
    ) {
        async function applyFilter(object = null, $scope, canvas) {
            const targetObject = object || $scope.imageSelected;

            if (!targetObject.imageFile) return;

            const blockUIMessage = 'Cutting Face ✂️';
            blockUI.start(blockUIMessage);

            try {
                const response = await CustomilyFaceCutOutAPIService.applyFilter(targetObject.imageFile);
                targetObject.oldFCCustImageFile = targetObject.imageFile;
                targetObject.imageFile = response;
                await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response], targetObject);
            } catch (error) {
                window.rumReportError(error);
                targetObject.oldFCCustImageFile = null;
                $timeout(() => $scope.$apply());
                $mdDialog.showCommonError(
                    error,
                    'Face Cut removal error' + (error.statusText ? ': ' + error.statusText : '!'),
                    'There seems to be an error with our face cut removal. Please contact our support team.'
                );
            } finally {
                $scope.$apply(() => blockUI.stop());
            }
        }

        return { applyFilter };
    }
})();
